export default {"src":"/_next/static/media/Topupcredit-pana.9737de0c.svg","height":428,"width":438};